import React from 'react'
import PropTypes from 'prop-types'

function CustomersHelped({ data, customersHelped }) {
  return (
    <section className="customers-helped">
      <div className="customers-helped__box">
        <h3 className="heading-sub-bold heading-section">{data.headline}</h3>
        <p className="customers-helped__number">{customersHelped}</p>
        <p className="customers-helped__text">{data.afterText}</p>
      </div>
    </section>
  )
}

CustomersHelped.propTypes = {
  data: PropTypes.object.isRequired,
  customersHelped: PropTypes.string.isRequired
}

export default CustomersHelped
